import { useState } from "react";
import { motion } from "framer-motion";
import api from "../utils/api";
import "./Register.css";

export default function AuthModal({ isOpen, onClose }) {
  const [isLogin, setIsLogin] = useState(true); // 🔀 toggle login/register
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  if (!isOpen) return null; // ❌ Modal hidden

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    if (isLogin) {
      // ✅ LOGIN
      const res = await api.post("/users/login", {
        email: form.email,
        password: form.password,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.user.role);

      onClose();
      window.location.reload();
    } else {
      // ✅ REGISTER
      const res = await api.post("/users/register", {
        name: form.name,
        email: form.email,
        password: form.password,
      });

      alert(res.data.msg || "Registered successfully ✅");
      setIsLogin(true); // 🔁 switch back to login
    }
  } catch (err) {
    alert(err.response?.data?.msg || "Error occurred");
  }
};


  return (
    <div className="modal-overlay">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="modal-content"
      >
        <button className="modal-close" onClick={onClose}>
          ✖
        </button>

        <h2 className="modal-title">
          {isLogin ? "Welcome Back 👋" : "Create Account 📝"}
        </h2>

        <form onSubmit={handleSubmit} className="modal-form">
          
          {!isLogin && (
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              value={form.name}
              onChange={handleChange}
              className="modal-input"
            />
          )}
         
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={form.email}
            onChange={handleChange}
            className="modal-input"
          />
         
          <input
            type="password"
            name="password"
            placeholder="Enter your password"
            value={form.password}
            onChange={handleChange}
            className="modal-input"
          />
          <button type="submit" className="modal-btn">
            {isLogin ? "Login" : "Register"}
          </button>
        </form>

        <div className="modal-switch">
          {isLogin ? (
            <p>
              Don’t have an account?{" "}
              <span onClick={() => setIsLogin(false)}>Register</span>
            </p>
          ) : (
            <p>
              Already have an account?{" "}
              <span onClick={() => setIsLogin(true)}>Login</span>
            </p>
          )}
        </div>
      </motion.div>
    </div>
  );
}
